import clsx from "clsx";
import React, { DetailedHTMLProps, FC, HTMLAttributes, PropsWithChildren } from "react";

import { colorScheme } from "./styles";
import { FormFieldColors } from "./types";

export interface FormFieldProps
  extends Pick<
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    "className" | "style"
  > {
  hasValue?: boolean;
  color: FormFieldColors;
  disabled?: boolean;
}

export const FormField: FC<PropsWithChildren<FormFieldProps>> = ({
  color = FormFieldColors.Light,
  hasValue,
  className,
  children,
  ...rest
}) => {
  const { inputClassName } = colorScheme[color];

  return (
    <div
      className={clsx(
        "flex items-center relative overflow-hidden w-full form-field rounded-md",
        "border border-neutral-dark focus-within:outline-primary focus-within:outline-2",
        "-outline-offset-1 focus-within:bg-primary-light focus-within:border-primary-light",
        hasValue && "outline-primary outline-1",
        inputClassName,
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};
